import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { ContextMenu, ContextMenuEntityUserActionsButton } from 'shared/mui/ContextMenu';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { MerchantAccount } from 'types/embedded/merchantAccount';

import { MerchantAccountShowDialogSkeleton } from './MerchantAccountShowDialogSkeleton';
import { MerchantAccountShowDialogTable } from './MerchantAccountShowDialogTable';

type Props = {
  open: boolean;
  onClose: () => void;
  merchantAccount?: MerchantAccount;
  handleOpenCredentialsDialog?: (record: MerchantAccount) => void;
  isFetching?: boolean;
};

export const MerchantAccountShowDialog: React.FC<Props> = ({
  open,
  onClose,
  merchantAccount,
  handleOpenCredentialsDialog,
  isFetching,
}) => {
  const translate = useTypedTranslate();
  const { hasResourceAccess } = usePermissions();

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <RecordContextProvider value={merchantAccount}>
        <CardHeader
          appendActions={[
            hasResourceAccess(Resources.UserActions) && (
              <ContextMenu key="context-menu-button">
                <ContextMenuEntityUserActionsButton entityName="merchant_account" />
              </ContextMenu>
            ),
            <CloseIconButton key="close-button" onClose={onClose} />,
          ]}
          title={translate('app.merchantAccount.details')}
          titleSize="smallBold"
        />
        <CardContent sx={{ marginBottom: '24px' }}>
          {isFetching ? (
            <MerchantAccountShowDialogSkeleton />
          ) : (
            <MerchantAccountShowDialogTable
              handleOpenCredentialsDialog={handleOpenCredentialsDialog}
              merchantAccount={merchantAccount}
              onClose={onClose}
            />
          )}
        </CardContent>
      </RecordContextProvider>
    </Dialog>
  );
};
